import React from 'react';
import Hero from '../components/HomePage/Hero';
import BibleVerse from '../components/HomePage/BibleVerse';
import FellowshipsTable from '../components/HomePage/FellowshipsTable';
import ServiceInfo from '../components/HomePage/ServiceInfo';

const HomePage = () => {
    return (
        <>
            <Hero/>
            <BibleVerse/>
            <ServiceInfo/>
            <FellowshipsTable/>
        </>
    );
}

export default HomePage;